<template>
    <div class="container">
        <div class="row">
            <div class="col-12 text-center py-10">

                <h1 class="mb-5">{{ $t('pages.configuration_finished.page_title') }}</h1>
<!--                <router-link :to="{ name: 'choose-product'}" class="btn btn-light">Continua gli acquisti</router-link>-->
                <router-link :to="{ name: 'checkout'}" class="btn btn-primary">{{ $t('pages.configuration_finished.action_checkout') }}</router-link>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        mounted() {
            this.$store.commit('prints/RESET_PRODUCT_SELECTED')
        }
    }
</script>